import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ArtistComboBox from "../ArtistComboBox";
import { artistsWithPublicationsApiRequest } from "../../../api";

const SearchBar = ({ onChange }) => {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    function onSuccess(response) {
      if (response.records && response.records.length > 0) {
        setArtists((artists) => [...artists, ...response.records]);
      }
    }

    const fetchData = () => {
      artistsWithPublicationsApiRequest({ all: 1 }, onSuccess);
    };

    fetchData();
  }, []);

  if (artists.length <= 0) return null;

  return (
    <div className="m-sibling-nav a-bg-blue50">
      <div className="m-sibling-nav__inner">
        <div className="m-sibling-nav__nav"></div>
        <ArtistComboBox
          artists={artists}
          onChange={onChange}
          label="Filter by artist"
          placeholder="Artist"
          wrapperClass="m-sibling-nav__form"
          theme="subnav"
        />
      </div>
    </div>
  );
};

SearchBar.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default SearchBar;
